module.exports = __webpack_public_path__ + "img/rummage.be0e1ec4.png";